<div class="row" style="margin-left: 0; margin-right: 0;">
  <div class="col-md-12">
    <div class="form-group">
      <div class="row">
        <label class="col-sm-2 col-form-label no-padding-right left-pos">
          <span class="labelWithToolTip no-padding-y">
             {{'admin.action_confirm.confirmation_text'|translate}}<span class="star">*</span>
          </span>
         <!--tooltip-item-->
         <span class="tooltip-item">
            <span class="tooltipBox">
              <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
            </span>
           <span class="desc-place">
           <ng-container>
             <div>
             {{'admin.action_confirm.confirmation_text_desc'|translate}}
             </div>
           </ng-container>
       </span>
          </span>
       </label>
       <div class="col-sm-6" >
         <input type="text" [name]="'confirmation'+Index" #message="ngModel" (ngModelChange)="updateSolution()"  [(ngModel)]="solution.solutionSteps[Index].actionConfirm.message"
                class="form-control" required>
       </div>
      </div>
    </div>

    <div class="form-group">
      <div class="row align-items-center">
          <label class="col-sm-2 col-form-label no-padding-right left-pos">
            <span class="labelWithToolTip no-padding-y">
               {{'admin.action_confirm.option'| translate:{number:1} }}<span class="star">*</span>
            </span>
           <!--tooltip-item-->
           <span class="tooltip-item">
              <span class="tooltipBox">
                <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
              </span>
             <span class="desc-place">
             <ng-container>
               <div>
               {{'admin.action_confirm.option_desc'|translate}}
               </div>
             </ng-container>
         </span>
            </span>
         </label>
         <div class="col-sm-6" >
            <input type="text" [name]="'confirmation_primary_option'+Index" #primaryOption="ngModel" (ngModelChange)="updateSolution()" [(ngModel)]="solution.solutionSteps[Index].actionConfirm.primaryOption"
                  class="form-control" required>
          </div>
          <label class="col-sm-1 col-form-label" style="padding-left:20px">
            <span class="labelWithToolTip no-padding-y">
               {{'admin.action_confirm.next_step'|translate}}
            </span>
         </label>
         <div class="col-sm-3" style="padding-left:21px" >
          <ng-select #primaryOptionStep="ngModel" [name]="'confirmation_primary_option_step'+Index"
                          [items]="solutionStepOptions"
                          [required]="true"
                          [(ngModel)]="solution.solutionSteps[Index].actionConfirm.primaryStep"
                          bindLabel="label"
                          bindValue="value"
                          (ngModelChange)="updateSolution()"
                          [clearable]="false">
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled text-black-50">
                    {{'doctrine.order.no_result_found_for'|translate}} {{searchTerm}}
                  </div>
                </ng-template>
                <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled text-black-50">
                    {{'doctrine.order.search_for'|translate}} {{searchTerm}}
                  </div>
                </ng-template>
              </ng-select>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="row align-items-center">
        <label class="col-sm-2 col-form-label no-padding-right left-pos">
            <span class="labelWithToolTip no-padding-y">
              {{'admin.action_confirm.option'| translate:{number:2} }}<span class="star">*</span>
            </span>
          <!--tooltip-item-->
          <span class="tooltip-item">
              <span class="tooltipBox">
                <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
              </span>
            <span class="desc-place">
            <ng-container>
              <div>
              {{'admin.action_confirm.option_desc'|translate}}
              </div>
            </ng-container>
        </span>
            </span>
        </label>
        <div class="col-sm-6">
          <input type="text" [name]="'confirmation_secondary_option'+Index" #secondaryOption="ngModel" (ngModelChange)="updateSolution()" [(ngModel)]="solution.solutionSteps[Index].actionConfirm.secondaryOption"
                  class="form-control" required>
        </div>
        <label class="col-sm-1 col-form-label" style="padding-left:20px">
          <span class="labelWithToolTip no-padding-y">
             {{'admin.action_confirm.next_step'|translate}}
          </span>
       </label>
       <div class="col-sm-3" style="padding-left:21px" >
         <ng-select #primaryOptionStep="ngModel" [name]="'confirmation_secondary_option_step'+Index"
                         [items]="solutionStepOptions"
                         [required]="true"
                         [(ngModel)]="solution.solutionSteps[Index].actionConfirm.secondaryStep"
                         (ngModelChange)="updateSolution()"
                         bindLabel="label"
                         bindValue="value"
                         [clearable]="false">
               <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                 <div class="ng-option disabled text-black-50">
                   {{'doctrine.order.no_result_found_for'|translate}} {{searchTerm}}
                 </div>
               </ng-template>
               <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
                 <div class="ng-option disabled text-black-50">
                   {{'doctrine.order.search_for'|translate}} {{searchTerm}}
                 </div>
               </ng-template>
             </ng-select>
       </div>
      </div>
    </div>

    <div class="form-group">
      <div class="row align-items-center">
        <div class="col-12">
          <div class="form-radio d-flex">
            <div class="radio radio-inline">
              <label>
                <input type="radio" [name]="'confirmation_type'+Index" [value]="getActionConfirm().BACKOFFICE_TYPE" (ngModelChange)="updateSolution()" [(ngModel)]="solution.solutionSteps[Index].actionConfirm.type">
                <i class="helper"></i>{{'admin.action_confirm.show_to_backoffice'|translate}}
              </label>
            </div>
            <div class="radio radio-inline">
              <label>
                <input type="radio" [name]="'confirmation_type'+Index" [value]="getActionConfirm().DEALER_TYPE" (ngModelChange)="updateSolution()" [(ngModel)]="solution.solutionSteps[Index].actionConfirm.type">
                <i class="helper"></i>{{'admin.action_confirm.show_to_dealer'|translate}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
